import React, {useContext, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import "./Authform.scss";
import UserContext from "../../context/UserContext";
import ErrorMessage from "../misc/ErrorMessage";
import domain from "../../util/domain";
const axios = require('axios').default;
const Web3 = require('web3');

function Login () {
    const [formEmail,setFormEmail] = useState("");
    const [formPassword,setFormPassword] = useState("");
    const [errorMessage,setErrorMessage]  = useState(null);
    const {getUser} = useContext(UserContext);
    const navigate = useNavigate();

    async function login(e) {
        e.preventDefault();

        const loginData = {
            email: formEmail,
            password: formPassword
        }
        try {
            await axios.post(domain + "/auth/login", loginData);
        }
        catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
            return;
        }
        await getUser();
        navigate("/");
    }

    async function logEth() {
        if (window.ethereum != null) {
            Web3.state = new Web3(window.ethereum);
        }
            try {
                await window.ethereum.enable();
            }
            catch (err) {
                console.log(err.json);
            }

}

    return <div className="auth-form">
        <h2>Log in</h2>
        {
            errorMessage && <ErrorMessage message={errorMessage}
                                          clear={() => setErrorMessage(null)} />
        }
        <form className="form" onSubmit={login}>
            <label htmlFor="form-email">Email</label>
            <input id="form-email"
                   type="email" value={formEmail}
                   onChange={(e) => setFormEmail(e.target.value)}/>
            <label htmlFor="form-password">Password</label>
            <input id="form-password"
                   type="password" value={formPassword}
                   onChange={(e) => setFormPassword(e.target.value)}/>

            <button className="btn-submit" type="submit">Log in</button>
        </form>
        <h2>Log in with Eth</h2>
        <button className="btn-submit" type="submit" onClick={logEth}>Web3 Log in</button>
        <p>Dont have an account yet <Link to="/register">Register here</Link></p>
    </div>
};

export default Login;